import React from "react";

interface GuestSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const GuestSearchBar: React.FC<GuestSearchBarProps> = ({
  value,
  onChange,
  placeholder = "Search guests here...",
  className = "",
}) => (
  <div className={`relative mb-6 ${className}`}>
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-full px-4 py-3 bg-white rounded-lg text-black placeholder-black/60 focus:outline-none focus:ring-2 focus:ring-black/30 transition-colors"
    />
    <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-white/40">
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    </div>
  </div>
);

GuestSearchBar.defaultProps = {
  placeholder: "Search guests here...",
  className: "",
};

export default GuestSearchBar;
